import React from 'react';
import block from 'bem-cn-lite';


class Comment extends React.Component {
    clickHandler = (e) => {
        e.preventDefault();
        const {onTrialLinkClick} = this.props;

        if (e.target.className === 'free-trial-link') {
            onTrialLinkClick();
        }
    }

    render() {
        const b = block('Comment');

        const {comment: {author, time, text, avatar, markerColor}} = this.props;

        return (
            <div className={b()}>
                <div className={b('avatar')}>
                    <img src={avatar} alt="avatar"/>
                    <span
                        className={b('marker')}
                        style={{background: markerColor}}>
                    </span>
                </div>
                <div>
                    <span className={b('author-name')}>{author}</span>
                    <span className={b('time')}>{time}</span>
                </div>
                <div className={b('text')}
                     onClick={this.clickHandler}
                     dangerouslySetInnerHTML={{__html: text}}></div>
            </div>
        )
    }
}


export default Comment;